// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"268":"fd6c9748","577":"0c2e1f88"}[chunkId] + ".chunk.css";
};